'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _renderUtils = require('../utils/renderUtils');

var _gallerySettings = require('../api/gallerySettings');

var _gallerySettings2 = _interopRequireDefault(_gallerySettings);

var _WixSdkWrapper = require('../sdk/WixSdkWrapper');

var _WixSdkWrapper2 = _interopRequireDefault(_WixSdkWrapper);

var _windowWrapper = require('../sdk/windowWrapper');

var _windowWrapper2 = _interopRequireDefault(_windowWrapper);

var _experimentsWrapper = require('../sdk/experimentsWrapper');

var _appSettings = require('../api/appSettings');

var _appSettings2 = _interopRequireDefault(_appSettings);

var _consts = require('../utils/consts');

var _consts2 = _interopRequireDefault(_consts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var watermarkDataKey = 'watermarkData';

var WatermarkApi = function () {
  function WatermarkApi(dataKey) {
    (0, _classCallCheck3.default)(this, WatermarkApi);

    this.dataKey = dataKey;
    this.defaultWatermarkData = {
      position: 9,
      size: 40,
      opacity: 40,
      imageUrl: '8bb438_9ad16b69fd1b4ab29324f97f1323b05a~mv2.png',
      imageRatio: 1.42517815
    };
    this.origOpacity = 40;

    this.emptyWatermarkData = {
      position: 1,
      size: 1,
      opacity: 1,
      imageUrl: '8bb438_39a78b46d4fe47069da63da9348b4ee5~mv2.png',
      imageRatio: 1
    };

    this.cachedWatermark = {
      default: this.defaultWatermarkData
    };

    this.disableWatermark = this.disableWatermark.bind(this);
    this.enableWatermark = this.enableWatermark.bind(this);

    try {
      this.protocol = _windowWrapper2.default.location.protocol;
      this.galleryId = _windowWrapper2.default.galleryId;
      this.instance = _windowWrapper2.default.instance;
    } catch (e) {
      this.protocol = 'http:';
      this.galleryId = '';
      this.instance = '';
    }
    this.appSettings = new _appSettings2.default();
    this.getWatermarkDataFromGallerySettingsServerAsync = this.getWatermarkDataFromGallerySettingsServerAsync.bind(this);
  }

  (0, _createClass3.default)(WatermarkApi, [{
    key: 'applyWatermarkOnMediaDialogResult',
    value: function applyWatermarkOnMediaDialogResult(mediaResult, galleryId, instance) {
      var _this = this;

      return new _promise2.default(function (resolve, reject) {
        if (mediaResult && mediaResult.length) {
          var watermarSave = null;
          _this.getWatermarkData(galleryId).then(function (watermarkData) {
            var imageUrl = watermarkData.imageUrl,
                position = watermarkData.position,
                size = watermarkData.size,
                opacity = watermarkData.opacity;

            watermarSave = watermarkData;
            var payload = {
              wm: 'media/' + imageUrl,
              wmop: opacity,
              wmpos: position,
              wmscl: size,
              files: mediaResult.map(function (item) {
                return { file_name: item.fileName };
              })
            };
            return _axios2.default.post(_this.protocol + '//progallery.wix.com/editor/api/v1/watermark/gallery/' + galleryId + '?instance=' + instance + '&isStore=true', payload, {
              withCredentials: true,
              xsrfCookieName: null
            });
          }).then(function () {
            resolve(watermarSave);
          });
        } else {
          reject();
        }
      });
    }
  }, {
    key: 'getCompId',
    value: function getCompId() {
      return new _promise2.default(function (resolve) {
        var compId = null;
        if (typeof _windowWrapper2.default !== 'undefined' && _windowWrapper2.default.isFullscreen) {
          compId = _renderUtils.renderUtils.getWorkerWindow()['pro-gallery-fullscreen-comp-id'];
        } else {
          compId = _WixSdkWrapper2.default.Utils.getOrigCompId() || _WixSdkWrapper2.default.Utils.getCompId() || 'default';
        }
        resolve(compId);
      });
    }
  }, {
    key: 'getDataKey',
    value: function getDataKey() {
      var _this2 = this;

      return new _promise2.default(function (resolve) {
        _this2.getCompId().then(function (compId) {
          var dataKey = _this2.dataKey + '-' + compId;
          resolve(dataKey);
        });
      });
    }
  }, {
    key: 'saveWatermark',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref, galleryId, instance) {
        var position = _ref.position,
            opacity = _ref.opacity,
            size = _ref.size,
            imageUrl = _ref.imageUrl,
            imageRatio = _ref.imageRatio;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_experimentsWrapper.experimentsWrapper.getExperimentBoolean('specs.pro-gallery.appSettings')) {
                  _context.next = 12;
                  break;
                }

                _context.prev = 1;
                _context.next = 4;
                return this.appSettings.set('watermark', { position: position, opacity: opacity, size: size, imageUrl: imageUrl, imageRatio: imageRatio });

              case 4:
                _context.next = 6;
                return _gallerySettings2.default.set('watermark', { position: position, opacity: opacity, size: size, imageUrl: imageUrl, imageRatio: imageRatio });

              case 6:
                return _context.abrupt('return', this._updateMediaWatermark(imageUrl, opacity, position, size, galleryId, instance));

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](1);

                console.error('Failed to set watermark in appSettings: ' + _context.t0);

              case 12:
                return _context.abrupt('return', this.saveWatermarkToGallerySettings({ position: position, opacity: opacity, size: size, imageUrl: imageUrl, imageRatio: imageRatio }, galleryId, instance));

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 9]]);
      }));

      function saveWatermark(_x, _x2, _x3) {
        return _ref2.apply(this, arguments);
      }

      return saveWatermark;
    }()
  }, {
    key: 'saveWatermarkToGallerySettings',
    value: function saveWatermarkToGallerySettings(_ref3, galleryId, instance) {
      var position = _ref3.position,
          opacity = _ref3.opacity,
          size = _ref3.size,
          imageUrl = _ref3.imageUrl,
          imageRatio = _ref3.imageRatio;

      var _this3 = this;

      return _gallerySettings2.default.set('watermark', { position: position, opacity: opacity, size: size, imageUrl: imageUrl, imageRatio: imageRatio }).then(function () {
        return _this3._updateMediaWatermark(imageUrl, opacity, position, size, galleryId, instance);
      });
    }
  }, {
    key: 'getCachedWatermark',
    value: function getCachedWatermark(compId) {
      return this.cachedWatermark[compId] || this.defaultWatermarkData;
    }
  }, {
    key: 'disableWatermark',
    value: function disableWatermark(galleryId, instance) {
      var _this4 = this;

      if (_renderUtils.renderUtils.isDev()) {
        console.log('Disabling watermark');
      }
      this.getCompId().then(function (compId) {
        var _getCachedWatermark = _this4.getCachedWatermark(compId),
            position = _getCachedWatermark.position,
            size = _getCachedWatermark.size,
            opacity = _getCachedWatermark.opacity,
            imageUrl = _getCachedWatermark.imageUrl,
            imageRatio = _getCachedWatermark.imageRatio;

        _this4.origOpacity = opacity; //save original opacity of the watermark
        opacity = 0;
        return _this4.saveWatermark({ position: position, size: size, opacity: opacity, imageUrl: imageUrl, imageRatio: imageRatio }, galleryId, instance);
      });
    }
  }, {
    key: 'enableWatermark',
    value: function enableWatermark(galleryId, instance) {
      var _this5 = this;

      if (_renderUtils.renderUtils.isDev()) {
        console.log('Enabling watermark');
      }
      this.getCompId().then(function (compId) {
        var _getCachedWatermark2 = _this5.getCachedWatermark(compId),
            position = _getCachedWatermark2.position,
            size = _getCachedWatermark2.size,
            imageUrl = _getCachedWatermark2.imageUrl,
            imageRatio = _getCachedWatermark2.imageRatio;

        var opacity = _this5.origOpacity; //retrieve original opacity of the watermark
        return _this5.saveWatermark({ position: position, size: size, opacity: opacity, imageUrl: imageUrl, imageRatio: imageRatio }, galleryId, instance);
      });
    }
  }, {
    key: '_updateMediaWatermark',
    value: function _updateMediaWatermark(imageUrl, opacity, position, size, galleryId, instance) {
      var _this6 = this;

      return new _promise2.default(function (resolve) {
        var payload = {
          wm: 'media/' + imageUrl,
          wmop: opacity,
          wmpos: position,
          wmscl: size
        };
        return _axios2.default.post(_this6.protocol + '//progallery.wix.com/editor/api/v1/watermark/gallery/' + galleryId + '?instance=' + instance + '&isStore=true', payload, {
          withCredentials: true,
          xsrfCookieName: null
        }).then(function () {
          resolve();
        });
      });
    }
  }, {
    key: 'getWatermarkDataFromGallerySettingsSync',
    value: function getWatermarkDataFromGallerySettingsSync(prerenderedGallery) {
      var watermarkData = null;
      if (prerenderedGallery && prerenderedGallery.gallerySettings) {
        var objGallerySettings = null;
        if (typeof prerenderedGallery.gallerySettings === 'string') {
          try {
            objGallerySettings = JSON.parse(_renderUtils.renderUtils.stripSlashes(prerenderedGallery.gallerySettings));
          } catch (error) {}
        } else if ((0, _typeof3.default)(prerenderedGallery.gallerySettings) === 'object') {
          objGallerySettings = prerenderedGallery.gallerySettings;
        }

        if (objGallerySettings) {
          watermarkData = objGallerySettings.watermark;
          if (watermarkData) {
            if (typeof watermarkData === 'string') {
              try {
                watermarkData = JSON.parse(watermarkData);
              } catch (error) {
                console.error('watermarkApi - watermark from gallery settings (' + watermarkData + ') is invalid', error);
              }
            }
          }
        }
      }

      return watermarkData;
    }
  }, {
    key: 'getWatermarkDataFromServerAsync',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(galleryId) {
        var watermark, _watermark, position, opacity, size, imageUrl, imageRatio;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_experimentsWrapper.experimentsWrapper.getExperimentBoolean('specs.pro-gallery.appSettings')) {
                  _context2.next = 25;
                  break;
                }

                _context2.prev = 1;
                _context2.next = 4;
                return this.appSettings.get(_consts2.default.dataSavedState.SAVED, 'watermark');

              case 4:
                watermark = _context2.sent;

                if (!(watermark !== undefined)) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt('return', _promise2.default.resolve(watermark));

              case 9:
                _context2.next = 11;
                return this.getWatermarkDataFromGallerySettingsServerAsync(galleryId);

              case 11:
                watermark = _context2.sent;

                if (!watermark) {
                  _context2.next = 19;
                  break;
                }

                //set watermark data in new app settings
                _watermark = watermark, position = _watermark.position, opacity = _watermark.opacity, size = _watermark.size, imageUrl = _watermark.imageUrl, imageRatio = _watermark.imageRatio;
                _context2.next = 16;
                return this.appSettings.set('watermark', { position: position, opacity: opacity, size: size, imageUrl: imageUrl, imageRatio: imageRatio });

              case 16:
                return _context2.abrupt('return', _promise2.default.resolve(watermark));

              case 19:
                return _context2.abrupt('return', _promise2.default.reject('watermarkApi - getWatermarkDataFromServerAsync - returned data from server is corrupt'));

              case 20:
                _context2.next = 25;
                break;

              case 22:
                _context2.prev = 22;
                _context2.t0 = _context2['catch'](1);

                console.error('Failed to get watermark from app settings: ' + _context2.t0);

              case 25:
                return _context2.abrupt('return', this.getWatermarkDataFromGallerySettingsServerAsync(galleryId));

              case 26:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 22]]);
      }));

      function getWatermarkDataFromServerAsync(_x4) {
        return _ref4.apply(this, arguments);
      }

      return getWatermarkDataFromServerAsync;
    }()
  }, {
    key: 'getWatermarkDataFromGallerySettingsServerAsync',
    value: function getWatermarkDataFromGallerySettingsServerAsync(galleryId) {
      var _this7 = this;

      galleryId = galleryId || this.galleryId;
      var instance = this.instance;
      return new _promise2.default(function (resolve, reject) {
        if (instance && galleryId) {
          _axios2.default.get(_this7.protocol + '//progallery.wix.com/_api/pro-gallery-editor-webapp/v1/gallery/' + galleryId + '?instance=' + instance + '&isStore=true', {
            withCredentials: true,
            xsrfCookieName: null
          }).then(function (response) {
            var data = response.data;

            if (data && (typeof data === 'undefined' ? 'undefined' : (0, _typeof3.default)(data)) === 'object' && data.settings && data.settings.watermark) {
              if (_experimentsWrapper.experimentsWrapper.getExperimentBoolean('specs.pro-gallery.appSettings')) {
                try {
                  _this7.appSettings.set('watermark', data.settings.watermark);
                } catch (error) {
                  console.error('Failed to set watermark in app settings: ' + error);
                }
              }

              resolve(data.settings.watermark);
            } else {
              reject('watermarkApi - getWatermarkDataFromServerAsync - returned data from server is corrupt');
            }
          }).catch(function () {
            reject('watermarkApi - getWatermarkDataFromServerAsync - request error');
          });
        } else {
          reject('watermarkApi - getWatermarkDataFromServerAsync - no galleryId (' + galleryId + ') or instance (' + instance + ')');
        }
      });
    }
  }, {
    key: 'getWatermarkData',
    value: function getWatermarkData(galleryId) {
      var _this8 = this;

      return new _promise2.default(function (resolve, reject) {
        _this8.getCompId().then(function (compId) {
          if (_this8.cachedWatermark[compId] && !_renderUtils.renderUtils.isEditor()) {
            // if (renderUtils.isDev()) console.log('Getting cached watermark');
            resolve(_this8.cachedWatermark[compId]);
          } else {
            var prerenderedItems = void 0;
            try {
              prerenderedItems = _windowWrapper2.default.prerenderedGallery || _windowWrapper2.default.prerenderedItem;
            } catch (e) {
              prerenderedItems = [];
            }
            _this8.cachedWatermark[compId] = _this8.getWatermarkDataFromGallerySettingsSync(prerenderedItems);
            // this.cachedWatermark = this.defaultWatermarkData; //set the default watermark until the Promise will resolve
            _renderUtils.renderUtils.isDev() && console.log('Getting public watermark');
            if (_this8.cachedWatermark[compId]) {
              resolve(_this8.cachedWatermark[compId]);
            } else {
              // fall back to data.public
              _this8.getWatermarkDataFromServerAsync(galleryId).then(function (watermarkData) {
                _this8.cachedWatermark[compId] = watermarkData;
                resolve(_this8.cachedWatermark[compId]);
              }).catch(function (e) {
                _renderUtils.renderUtils.isDev() && console.log('Getting watermark from server failed - ', e);
                _this8.cachedWatermark[compId] = new _promise2.default(function () {
                  _this8.getDataKey().then(function (dataKey) {
                    if (_WixSdkWrapper2.default && _WixSdkWrapper2.default.Data && _WixSdkWrapper2.default.Data.Public) {
                      _WixSdkWrapper2.default.Data.Public.get(dataKey, { scope: _WixSdkWrapper2.default.Data.SCOPE.APP }, function (data) {
                        if (_renderUtils.renderUtils.isDev()) {
                          console.log('Got watermark from Data.Public', data);
                        }
                        var parsedData = JSON.parse(data[dataKey]);
                        _this8.cachedWatermark[compId] = parsedData;
                        resolve(parsedData);
                      }, function (e) {
                        if (_renderUtils.renderUtils.isDev()) {
                          console.log('cannot fetch watermark from Data.Public', e);
                        }

                        _this8.cachedWatermark[compId] = _this8.defaultWatermarkData;
                        resolve(_this8.cachedWatermark[compId]);
                      });
                    } else {
                      if (_renderUtils.renderUtils.isDev()) {
                        console.log('Cannot get watermark from Data.Public (wix not found)');
                      }
                      reject('Wix not found');
                    }
                  });
                });
              });
            }
          }
        });
      });
    }
  }]);
  return WatermarkApi;
}();

exports.default = new WatermarkApi(watermarkDataKey);